"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameEvent = void 0;
class GameEvent {
    type;
    params;
    constructor(type, params = null) {
        this.type = type;
        this.params = params;
    }
    getType() {
        return this.type;
    }
    getParams() {
        return this.params;
    }
}
exports.GameEvent = GameEvent;
